module.exports = __webpack_public_path__ + "img/skirt side seam.c8ccbac5.png";